export const NumeratorsCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Sistema',
    path: '/sistema',
  },
  {
    name: 'Numeratori',
    path: '/sistema/numeratori',
  },
];
